/* @flow */

export const OAUTH_MESSAGE_TYPE = 'oauth';
export const OAUTH_MESSAGE_ACTION_SLACK = 'slackOauth';
